import { Select, type SelectProps } from 'antd';
import { type BaseOptionType, type DefaultOptionType } from 'antd/es/select';
import styled, { css } from 'styled-components';

export const KeyValueSelectContainer = styled.div`
  display: flex;
  align-items: center;
  height: 30px;

  .operator {
    color: rgb(0 0 0 / 45%);
    font-size: 18px;
    background: #f5f5f5 !important;
    border: 1px solid #d9d9d9;
    border-left: 0;
    border-right: 0;
    height: 28px;
    line-height: 28px;
    padding: 0 4px;
  }

  .delete-icon-container {
    background: #f5f5f5 !important;
    height: 28px;
    cursor: pointer;
    color: rgb(0 0 0 / 45%);
    font-size: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 8px;
    border: 1px solid #d9d9d9;
    border-top-right-radius: 2px;
    border-bottom-right-radius: 2px;
    border-left: 0;

    &:hover {
      color: rgb(0 0 0 / 88%);
    }
  }
`;

export const KeySelect = styled(Select)<
  SelectProps<any, BaseOptionType | DefaultOptionType> & {
    $showLeftBorder?: boolean;
    style?: React.CSSProperties;
  }
>`
  .gm-ant-select .gm-ant-select-in-form-item {
    width: ${(props) => props.style?.width || 'fit-content'} !important;
    height: ${(props) => props.style?.height || '30px'};
  }

  &&.gm-ant-select {
    max-width: ${(props) => props.style?.maxWidth || 'fit-content'};
    width: ${(props) => props.style?.width || 'fit-content'} !important;
    display: inline-flex;
    flex: 1;
    height: ${(props) => props.style?.height || '30px'};

    .gm-ant-select-selector {
      width: fit-content;
      background: ${(props) =>
        props.style?.background || props.style?.backgroundColor || '#f5f5f5'} !important;
      border-radius: ${(props) => props.style?.borderRadius || '0'};
      border-top-left-radius: ${(props) => props.style?.borderRadius || '2px'};
      border-bottom-left-radius: ${(props) => props.style?.borderRadius || '2px'};
      padding: ${(props) => props.style?.padding || '0 8px 0 12px'};
      align-items: center;
      height: ${(props) => props.style?.height || '30px'};

      .gm-ant-select-selection-wrap {
        width: fit-content;
        min-width: calc(100% + 50px);
      }

      .gm-ant-select-selection-item {
        white-space: nowrap;
        width: fit-content;
        min-width: calc(100% + 50px);
        height: fit-content;
      }

      .gm-ant-select-selection-placeholder {
        color: ${(props) => props.style?.color || 'rgba(0, 0, 0, 0.45)'};
      }
    }

    .gm-ant-select-arrow {
      color: ${(props) => props.style?.color || 'rgba(0, 0, 0, 0.45)'};
    }

    &.gm-ant-select-disabled .gm-ant-select-selector .gm-ant-select-selection-item {
      color: rgb(0 0 0 / 88%);
    }
  }

  &.gm-ant-select:not(.gm-ant-select-focused, :hover) {
    .gm-ant-select-selector {
      border-right: 0;
      ${({ $showLeftBorder = true }) => {
        if (!$showLeftBorder) {
          return css`
            border-left: 0;
          `;
        }
        return;
      }}
    }
  }

  &.gm-ant-select.gm-ant-select-compact-item {
    margin-inline-end: 0;
  }

  &.gm-ant-select-disabled:hover {
    .gm-ant-select-selector {
      border-right: 0;
    }
  }
`;

export const ValueSelect = styled(Select)<
  SelectProps<any, BaseOptionType | DefaultOptionType> & {
    $showRightBorder?: boolean;
    $minWidth?: string;
    selectedCount?: number;
  }
>`
  &.gm-ant-select {
    display: inline-flex;
    flex: 1;
    min-width: 0;
    height: 30px;

    .gm-ant-select-selector {
      width: fit-content !important;
      min-width: ${({ $minWidth }) => ($minWidth ? $minWidth : '83px')};
      border-radius: 0;
      border-top-right-radius: 2px;
      border-bottom-right-radius: 2px;
      flex-grow: 1;
      height: 30px;

      .gm-ant-select-selection-placeholder {
        color: rgb(0 0 0 / 25%);
      }

      .gm-ant-select-selection-overflow-item {
        max-width: ${({ selectedCount }) =>
          selectedCount && selectedCount > 1 ? 'calc(100% - 60px)' : '100%'};
      }
    }
  }

  &:not(.gm-ant-select-focused, :hover) {
    .gm-ant-select-selector {
      border-left: 0;
      ${({ $showRightBorder = true }) => {
        if (!$showRightBorder) {
          return css`
            border-right: 0;
          `;
        }
        return;
      }}
    }
  }

  &.gm-ant-select-disabled:hover {
    .gm-ant-select-selector {
      border-left: 0;
    }
  }

  &.gm-ant-select-status-error {
    .gm-ant-select-selector {
      border-left: 1px solid #ff7875 !important;
    }
  }
`;
